import { cloneDeep, isEmpty, pickBy } from "lodash";
import { apiSlice } from "./apiSlice";
import store from "src/_store/store"
import { $BASE_URL, ROLES } from "src/constants";
const apiUrl = $BASE_URL + '/api';

const getGlobalFilterCriteria = (params, warehouseTypeArray = false) => {
    const state = store.getState()
    let customizations = cloneDeep(state?.entities?.customizations)
    let customizationsExistedData = pickBy(customizations, v => !isEmpty(v))
    if (!isEmpty(customizationsExistedData)) {
        if (!!customizationsExistedData?.warehouse) {
            if (warehouseTypeArray) {
                customizationsExistedData.warehouse = [customizationsExistedData?.warehouse?.id]
            } else {
                customizationsExistedData.warehouse = customizationsExistedData?.warehouse?.id
            }
        }
        return { ...params, ...customizationsExistedData }
    }
    return params
}


export const driverApi = apiSlice.injectEndpoints({
    keepUnusedDataFor: 1,
    endpoints: builder => ({
        getDrivers: builder.query({
            query: (params) => ({
                url: `/driver`,
                method: 'GET',
                params: getGlobalFilterCriteria(params)
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getFreelanceDriverProfile: builder.query({
            query: () => {
                return {
                    url: `/driver/profile`,
                    method: 'GET'
                }
            },
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        updateFreelanceDriverProfile: builder.mutation({
            query: (payload) => {
                return {
                    url: `/driver`,
                    method: 'PUT',
                    body: { ...payload }
                }
            },
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        updateFreelanceDriverPassword: builder.mutation({
            query: (payload) => {
                return {
                    url: "/driver/update-password",
                    method: 'PUT',
                    body: { ...payload }
                }
            },
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        updateFreelanceDriverStatus: builder.mutation({
            query: ({ id, payload }) => {
                return {
                    url: `/driver/update-status/${id}`,
                    method: 'PUT',
                    body: { ...payload }
                }
            },
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getDriverStatsEnaab: builder.query({
            query: (params) => ({
                url: `/task-completion-log`,
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getDriverStatsEnaabExcel: builder.query({
            query: (params) => ({
                url: `/task-completion-log/xlsx`,
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
    })
})

export const {
    useGetDriversQuery,
    useLazyGetDriversQuery,
    useGetFreelanceDriverProfileQuery,
    useUpdateFreelanceDriverProfileMutation,
    useUpdateFreelanceDriverPasswordMutation,
    useUpdateFreelanceDriverStatusMutation,
    useGetDriverStatsEnaabQuery,
    useLazyGetDriverStatsEnaabExcelQuery,
} = driverApi